<template>
    <div class="signup">

        <!--Preloader-->
        <Preloader
            v-if="preloaderShow"
        ></Preloader>

        <!--Error-->
        <ErrorModal
            v-if="errorPopup"
            title="Error"
            message="An error occurred."
            @dismissError="dismissError"
        ></ErrorModal>

        <!-- Landing -->
        <Landing v-if="displayLanding" @nextStep="nextStep"/>

        <!-- Steps -->
        <div v-else class="signup__container">

            <!-- <div class="signup__prev">
                <a href="#" class="prevButton" @click.prevent="prevStep">
                    <ArrowIcon></ArrowIcon>
                </a>
            </div> -->

            <div class="signup__step">
                <span class="orange">{{stepIdx + 1}}</span> / <span>{{stepComponent.length}}</span>
            </div>

            <component :is="stepComponent[stepIdx]" @nextStep="nextStep" @showLoading="showLoading" @dismissLoading="dismissLoading" @showError="showError"/>
        </div>
    </div>
</template>

<script>
    import ArrowIcon from '@/assets/svg/arrow.svg';

    import ErrorModal from '@/components/1-common/ErrorModal';
    import Preloader from '@/components/1-common/Preloader';
    import Landing from '@/components/3-pages/Landing';
    // import step1 from '@/components/2-blocks/step1';
    // import step2 from '@/components/2-blocks/step2';
    // import step3 from '@/components/2-blocks/step3';
    import Step1_AccHolder from '@/components/2-blocks/Step1_AccHolder';
    import Step2_MakeAcc from '@/components/2-blocks/Step2_MakeAcc';
    import Step3_MobileNum from '@/components/2-blocks/Step3_MobileNum';
    import Step4_AddContacts from '@/components/2-blocks/Step4_AddContacts';
    import Step5_CreditCard from '@/components/2-blocks/Step5_CreditCard';
    import Step6_MakeNum from '@/components/2-blocks/Step6_MakeNum';
    import Step7_OhanaNum from '@/components/2-blocks/Step7_OhanaNum';
    import Step8_Welcome from '@/components/2-blocks/Step8_Welcome';

    export default {
        name: 'Signup',
        components: {
            ArrowIcon,
            Landing,
            ErrorModal,
            Preloader
        },
        mounted() {
            console.log('Signup mounted')
            amplitude.getInstance().logEvent('signup_loaded');
        },
        data() {
            return {
                stepComponent: [
                    Step1_AccHolder,
                    Step2_MakeAcc,
                    Step3_MobileNum,
                    Step4_AddContacts,
                    Step5_CreditCard,
                    Step6_MakeNum,
                    Step7_OhanaNum,
                    Step8_Welcome,
                ],
                stepIdx: 0,
                displayLanding: true,
                errorPopup: false, // Show Error Popup
                preloaderShow: false, // Show Preloader
                currentUid: null,
                currentName: null,
                currentEmail: null,
                ohanaNumber: null
            }
        },
        methods: {

            showLoading() {
                // console.log('showLoading called');
                this.preloaderShow = true;
            },

            dismissLoading() {
                console.log('dismissing loading');
                this.preloaderShow = false;
            },

            showError(message) {
                console.log('show error called');
                this.error_message = message;
                this.errorPopup = true;
            },

            dismissError() {
                console.log('dismissing error');
                this.errorPopup = false;
            },

            prevStep() {
                if (this.stepIdx === 0) {
                    this.displayLanding = true;
                } else {
                    this.stepIdx = this.stepIdx - 1;
                }
            },

            nextStep() {

                if (this.displayLanding) {
                    this.displayLanding = false;
                    return
                }

                this.stepIdx = this.stepIdx + 1;
            },
        },
    }
</script>




// WEBPACK FOOTER //
// Signup.vue?59556fa6